module.exports = __webpack_public_path__ + "img/loisir3.1d31569e.jpg";